import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export const useError404Page = () => {
  const { t } = useTranslation("error404")
  const navigate = useNavigate()

  return { t, navigate }
}
